export default (number, fractionSize = 0) => {
  if (number === null || Number.isNaN(number)) return '';
  return parseFloat(number)?.toLocaleString(undefined, {
    minimumFractionDigits: fractionSize,
    maximumFractionDigits: fractionSize,
  });
};
